import { createAction } from '@reduxjs/toolkit';

export const getLoyaltyWalletReq = createAction(
	'loyalty-wallet/getLoyaltyWalletReq'
);
